
<template>
  <el-card class="arc_row_card">
    <template #header>{{ arc_title }}</template>
    <div class="content" v-html="content"></div>
  </el-card>
</template>
<script>
export default {
  props: ['content','arc_title'],
  setup() {

    return {

    }
  }
}
</script>
<style scoped>

</style>